import axios from 'axios'
import store from '@/store'

export default {
  getCurrencies () {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/finances/currencies', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          ({ data }) => {
            store.dispatch('setCurrencies', data)
            resolve(true)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getBankCards () {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/finances/bank-cards', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          ({ data }) => {
            store.dispatch('setBankCards', data)
            resolve(true)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getInvoiceProjectSpecialisations () {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/finances/invoice/project-specialisations', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/setSpecialisations', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  createInvoiceProjectSpecialisations (payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/finances/invoice/project-specialisations', payload, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/addSpecialisation', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removeInvoiceProjectSpecialisations (id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/finances/invoice/project-specialisations/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/removeSpecialisation', id)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  editInvoiceProjectSpecialisations (payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `/api/finances/invoice/project-specialisations/${payload.id}`,
          payload,
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }
        )
        .then(
          res => {
            store.dispatch('finances/editSpecialisation', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },

  getBusinessEntityTypesController () {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/finances/business-entity-types', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/setBusinessEntityTypes', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getInvoicesTypes () {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/finances/invoices-types', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/setInvoicesTypes', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getPayoutsTypes () {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/finances/payouts-types', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/setPayoutsTypes', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getAllFinanceClients () {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/finances/all-clients', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/setAllClients', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },

  getBankDetails (params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/bank-details${params}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/setBankDetails', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removeBankDetails (id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/finances/bank-details/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  createBankDetails (payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/finances/bank-details/`, payload, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  editBankDetails (payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/finances/bank-details/${payload.id}`, payload, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },

  getBankDetailsCards () {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/bank-cards`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/setBankDetailsCards', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removeBankDetailsCards (id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/finances/bank-cards/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/removeBankDetailsCards', id)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  createBankDetailsCards (payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/finances/bank-cards/`, payload, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/addBankDetailsCards', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  editBankDetailsCards (payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/finances/bank-cards/${payload.id}`, payload, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/editBankDetailsCards', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },

  getBankDetailsSigns () {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/bank-details-signs`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/setBankDetailsSigns', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getBankDetailsAll () {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/bank-details-all`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/setBankAllDetails', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getClients (params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/clients${params}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/setClients', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  createClients (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/finances/clients/`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removeClient (id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/finances/clients/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  editClient (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/finances/clients/${params.id}`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },

  getInvoices (params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/invoices${params}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/setInvoices', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  createInvoices (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/finances/invoices`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  updateInvoices (params) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/finances/invoices/${params.id}`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  markInvoicePaid (invoiceId) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/finances/invoices/${invoiceId}/mark-paid`, {}, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removeInvoices (id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/finances/invoices/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  calculateTotalAmount (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/finances/invoices/calculate-total-amount`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getInvoice (id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/invoices/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res.data)
          },
          error => {
            reject(error)
          }
        )
    })
  },

  getInvoicesStatuses () {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/invoices-statuses`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/setInvoicesStatuses', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getInvoicesTemplate () {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/invoices-template-types`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/setInvoicesTemplates', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },

  getPayouts (params, setPayouts = true) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/payouts${params}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            if (setPayouts) {
              store.dispatch('finances/setPayouts', res.data)
            }
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  createPayouts (params) {
    return new Promise((resolve, reject) => {
      store.dispatch('finances/setIsModalLoading', true)
      axios
        .post(`/api/finances/payouts`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
        .finally(() => {
          store.dispatch('finances/setIsModalLoading', false)
        })
    })
  },
  updatePayouts (params) {
    return new Promise((resolve, reject) => {
      store.dispatch('finances/setIsModalLoading', true)
      axios
        .put(`/api/finances/payouts/${params.id}`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
        .finally(() => {
          store.dispatch('finances/setIsModalLoading', false)
        })
    })
  },
  markPayoutPaid (payoutId) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/finances/payouts/${payoutId}/mark-paid`, {}, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removePayouts (id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/finances/payouts/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removePayoutsInBulk (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/finances/payouts/remove-in-bulk`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getPayout (id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/payouts/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res.data)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getPayoutsStatuses () {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/payouts-statuses`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/setPayoutsStatuses', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getPayoutsTemplateTypes () {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/payouts-template-types`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/setPayoutsTemplateTypes', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },

  getClientsBankDetailsByProject (id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/clients/bank-details-by-project/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },

  getContractorBankDetails (id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/contractors/${id}/bank-details`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },

  getPartnerBankDetails (id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/partners/${id}/bank-details`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },

  getReportsInvoices (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/finances/reports/invoices`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getInvoicesPeriodTypes () {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/invoices-period-types`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('finances/setInvoicesPeriodTypes', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getReportsExpenses (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/finances/reports/expenses`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getReportsPayrolls (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/finances/reports/payrolls`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getReportsProfitAndLoss (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/finances/reports/profit-and-loss`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getReportsProfitAndLossCalculator (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/finances/reports/profit-and-loss-calculator`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getReportsProfitAndLossHistorical (showLastMonth) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/finances/reports/profit-and-loss-historical`, { 'show-last-month': showLastMonth }, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getReportsPeopleAndProjects (params) {
    return new Promise((resolve, reject) => {
      axios
        .post('api/finances/reports/people-and-projects', params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getReportsHoursAndPayments (params) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/finances/reports/hours-and-payments', params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getReportsHoursAndPaymentsOverview (params) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/finances/reports/hours-and-payments-overview', params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getReportsSales (params) {
    return new Promise((resolve, reject) => {
      axios
        .post('api/finances/reports/sales', params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getReportsSalesHistorical (params) {
    return new Promise((resolve, reject) => {
      axios
        .post('api/finances/reports/sales-historical', params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getTaxTypes () {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/finances/tax-types',
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }
        )
        .then(
          ({ data }) => {
            store.dispatch('finances/setTaxTypes', data)
            resolve(true)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getSalesChannels () {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/finances/sales-channels',
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }
        )
        .then(
          ({ data }) => {
            store.dispatch('finances/setSalesChannels', data)
            resolve(true)
          },
          error => {
            reject(error)
          }
        )
    })
  }
}
